const NUMBER_REGEX = /\d/;
const SPECIAL_CHARACTER_REGEX = /[!@#$%^&*(),.?":{}|<>_\-+=[\]\\/;'`~]/;

export const newPasswordRules = (t, global, newPassword) => {
  const minPasswordLength = global.passwords.min_length;
  const maxPasswordLength = global.passwords.max_length;

  if (!newPassword || typeof newPassword !== 'string') {
    return [t('login.wrong_password_format')];
  }

  if (newPassword.length < minPasswordLength) {
    return [t('login.password_too_short', { length: minPasswordLength })];
  }

  if (newPassword.length > maxPasswordLength) {
    return [t('login.password_too_long', { length: maxPasswordLength })];
  }

  if (!NUMBER_REGEX.test(newPassword)) {
    return [t('login.password_missing_number')];
  }

  if (!SPECIAL_CHARACTER_REGEX.test(newPassword)) {
    return [t('login.password_missing_special_character')];
  }

  return [];
};

export const parseErrorsIntoString = errors => {
  let returnStringList = [];

  if (typeof errors === 'object') {
    Object.keys(errors).forEach( key => {
      const error = errors[key];

      if (Array.isArray(error)) {
        returnStringList = [...returnStringList, ...error];
      }
      else if (typeof error === 'string') {
        returnStringList.push(error);
      }
    });
  }
  else if (Array.isArray(errors)) {
    returnStringList = [...returnStringList, ...errors];
  }
  else if (typeof errors === 'string') {
    returnStringList.push(errors);
  }

  return [...new Set(returnStringList)].reduce((acc, string) => (`${acc} ${string}`), '').trim();
};
